import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../../config';
import ArticlesGrid from '../components/ArticlesGrid';
import Pagination from '../components/Pagination';
import { POSTS_PER_PAGE } from './HomePage';

function SearchPage() {
    const [searchParams] = useSearchParams();
    const query = (searchParams.get('q') || searchParams.get('s') || '').trim();
    const requestedPage = parseInt(searchParams.get('page'), 10);
    const currentPage = Number.isFinite(requestedPage) && requestedPage > 0 ? requestedPage : 1;

    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(Boolean(query));

    useEffect(() => {
        if (!query) {
            setResults([]);
            setLoading(false);
            return undefined;
        }

        let active = true;
        setLoading(true);

        const search = async () => {
            try {
                const response = await axios.get(
                    `${API_URL}/api/posts?search=${encodeURIComponent(query)}&limit=100`
                );
                if (active) {
                    const posts = Array.isArray(response.data?.posts) ? response.data.posts : [];
                    setResults(posts);
                }
            } catch (error) {
                console.error('[ERROR] Search failed:', error);
                if (active) {
                    setResults([]);
                }
            } finally {
                if (active) {
                    setLoading(false);
                }
            }
        };

        search();

        return () => {
            active = false;
        };
    }, [query]);

    const totalPages = Math.max(1, Math.ceil(results.length / POSTS_PER_PAGE));
    const page = Math.min(currentPage, totalPages);
    const start = (page - 1) * POSTS_PER_PAGE;
    const pagePosts = results.slice(start, start + POSTS_PER_PAGE);

    return (
        <>
            <header className="search-results-header">
                <div className="eyebrow" style={{ marginBottom: '.4rem' }}>Search Results</div>
                <h1>{query}</h1>
            </header>
            {loading ? (
                <p className="small-meta site-loading">Searching …</p>
            ) : results.length === 0 ? (
                <p className="small-meta" style={{ padding: '2rem 0' }}>No results found.</p>
            ) : (
                <>
                    <ArticlesGrid posts={pagePosts} />
                    <Pagination
                        currentPage={page}
                        totalPages={totalPages}
                        getPageLink={(target) => (
                            `/search?q=${encodeURIComponent(query)}${target > 1 ? `&page=${target}` : ''}`
                        )}
                    />
                </>
            )}
        </>
    );
}

export default SearchPage;
